/**
 * L2-S5: moved to @miq/platform (lib/editing-box/editing-box.service.ts). This shim keeps the old
 * import path working; new code should import from '@miq/platform'.
 *
 * It was the reports remote's last [A]-classified seam: `_cachedColumns` is shared mutable state,
 * so the remote's duplicate bundle produced TWO caches. It now resolves to the one federated
 * instance — which is what `reports` and `records` shared before the L2-R4 remote split.
 *
 * The three box COMPONENT classes it projects stay HERE; the host hands them to the library
 * through `EDITING_BOX_COMPONENTS` in src/app/app.config.ts.
 */
export { EditingBoxService } from '@miq/platform';
